module.exports = __webpack_public_path__ + "img/banner01.af6707c0.jpg";